import { Box, styled } from '@mui/material';

export const CardProductsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
}));

export const CardItemsWrapper = styled(Box)(({ theme }) => ({
  maxHeight: '300px',
  overflowY: 'auto',
  paddingRight: theme.spacing(1),
}));

export const CardProductsHeaderBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(0, 1),
  justifyContent: 'space-between',
}));

export const CardProductsHeaderBox = styled(Box)(() => ({
  display: 'flex',
  gap: 1,
  alignItems: 'center',
}));

export const ArrowCascaderBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(1),
  cursor: 'pointer',
}));

export const CardBatchDetailBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const CardProductContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(1),
  justifyContent: 'space-between',
}));
